module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjMDAwMGI0IiBkPSJNMCAwaDY0MHY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDc1LjQyOGg2NDB2MzIyLjI4NUgweiIvPgogICAgPHBhdGggZmlsbD0iI2Q5MDAwMCIgZD0iTTAgMTU3LjcxNmg2NDBWMzE1LjQzSDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/cr.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/cr.svg
// module chunks = 0